import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { callApi, CDN_URL, formatDate, getInlineLoader } from "../Helpers"

export default function View({ uuid }) {
  const appContext = useContext(AppContext)

  const [ready, setReady] = useState(false)
  const [data, setData] = useState(null)

  async function init() {
    setReady(false)
    await Promise.all([getData()])
    setReady(true)
  }

  async function getData() {
    await callApi("get-project-data", { uuid }).then((response) => {
      if (response.status === 1) {
        setData(response.data)
      } else {
        appContext.tellError("Could not fetch data")
      }
    })
  }

  useEffect(() => {
    init()
  }, [])

  if (ready && data) {
    const mediaUrl = CDN_URL + data.coverPhoto
    const isVideo = /\.(mp4|webm|ogg)$/i.test(data.coverPhoto)

    return (
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h6 className="main-section-title font-semi-bold">
              {data.title}
            </h6>
          </div>

          <div className="col-md-12 mt-2 mb-2">
            {isVideo ? (
              <video
                src={mediaUrl}
                controls
                style={{ width: "100%" }}
              />
            ) : (
              <img
                src={mediaUrl}
                style={{ width: "100%" }}
              />
            )}
          </div>

          <div className="col-md-12 mt-2 mb-2">
            <h6
              style={{ fontSize: "12px" }}
              className="text-end text-muted font-semi-bold"
            >
              {formatDate(data.dateCreated)}
            </h6>
            <hr />
          </div>

          <div className="col-md-12 mt-2 mb-2">
            <div
              style={{
                width: "100%",
                padding: "0",
                overflow: "hidden",
              }}
              dangerouslySetInnerHTML={{ __html: data.body }}
            />
          </div>
        </div>
      </div>
    )
  } else {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    )
  }
}